import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Category, UpdateCategoryRequest } from '@models/category.model';
import { environment } from '@environment/environment';
import { mapCategoryToUpdateRequest } from '@modules/shared/services/mappers/category.mapper';

@Injectable({providedIn: 'root'})
export class CategoryService {
  private readonly http = inject(HttpClient);
  private readonly ENDPOINT = 'categories';

  getAll(webshopId: string): Observable<Category[]> {
    return this.http.get<Category[]>(`${environment.apiBaseUrl}/webshops/${webshopId}/${this.ENDPOINT}`);
  }

  update(request: { webshopId: string, category: Partial<Category> & { id: string } }): Observable<Category> {
    const category = mapCategoryToUpdateRequest(request.category as Category);
    return this.http.patch<Category>(`${environment.apiBaseUrl}/webshops/${request.webshopId}/${this.ENDPOINT}/${category.id}`, category);
  }

  create(request: UpdateCategoryRequest): Observable<Category> {
    return this.http.post<Category>(`${environment.apiBaseUrl}/webshops/${request.webshopId}/${this.ENDPOINT}`, request.category);
  }

  delete(request: { webshopId: string, categoryId: string }): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/webshops/${request.webshopId}/${this.ENDPOINT}/${request.categoryId}`);
  }
}
